import { render } from "./AppMailSuccess.vue?vue&type=template&id=75c96d8a&scoped=true"
import script from "./AppMailSuccess.vue?vue&type=script&lang=js"
export * from "./AppMailSuccess.vue?vue&type=script&lang=js"

import "./AppMailSuccess.vue?vue&type=style&index=0&id=75c96d8a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c96d8a"]])

export default __exports__